import React, { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './ChallengesSection.css';
import {
  FaRegLightbulb,
  FaChalkboardTeacher,
  FaUsers,
  FaBullhorn,
  FaBookOpen,
} from 'react-icons/fa';

const challenges = [
  { icon: <FaRegLightbulb />, title: "Counselling Void", desc: "General Deep Counselling is often absent, leaving students without direction, especially for middle class students. Thorough Career Counselling is marred by limited and business interest. Parental Counselling is virtually non-existent, though parents play a crucial role" },
  { icon: <FaChalkboardTeacher />, title: "Tuition Dependency", desc: "Students rely heavily on external coaching due to the lack of online academic support." },
  { icon: <FaUsers />, title: "Weak Bonding", desc: "There is a lack of systemic approach to build loyal parent communities or involve students meaningfully." },
  { icon: <FaBullhorn />, title: "Poor Branding", desc: "Most schools are not able to utilise and leverage social media like Instagram, YouTube, and Facebook to connect with their neighbourhood and build trust locally." },
  { icon: <FaBookOpen />, title: "Academic Gap", desc: "Schools aspire to prepare students for prestigious exams like IIT-JEE and NEET, yet lack structured, in-house academic mentorship." }
];

function ChallengesSection() {
  useEffect(() => {
    AOS.init({ duration: 1000, easing: 'ease-in-out', once: false });
    AOS.refresh();
  }, []);

  return (
    <div className="unique-challenges-section">
      <Container>
        <h2 className="unique-challenges-title" data-aos="fade-up">The Challenges Schools Face</h2>
        <div className="unique-timeline">
          {challenges.map((item, idx) => (
            <div
              key={idx}
              className={`unique-timeline-item ${idx % 2 === 0 ? 'left' : 'right'}`}
              data-aos={idx % 2 === 0 ? 'fade-right' : 'fade-left'}
              data-aos-delay={idx * 100}
            >
              <div className="unique-sequence-number">{idx + 1}</div> {/* Circle Number */}
              <div className="unique-icon">{item.icon}</div>
              <div className="unique-content">
                <h5>{item.title}</h5>
                <p>{item.desc}</p>
              </div>
            </div>
          ))}
          <div className="unique-vertical-line" />
        </div>
        <p className="unique-conclusion-text" data-aos="fade-up">
  Therefore, we propose a strategic partnership with your school to address these challenges and transform your institution into a highly recognized local leader in education.
</p>
      </Container>
    </div>
  );
}

export default ChallengesSection;
